import { Prescriptions } from "../patients/shared/models";

export class PrescriptionBulk {
    prescriptions: Prescriptions[]
    constructor(data?: Partial<Prescriptions[]>) {
        this.prescriptions = data;
    }
}